<template>
    <div class="side-nav-padding">
        <div class="d-flex flex-column-reverse flex-md-row gap-4">
            <div class="d-flex flex-column gap-4" style="flex-grow: 3;min-width: 200px">
                <div>
                    <p class="fs-5 fw-600 mb-1 text-muted">{{$trans('storefront::image_editor.font')}}</p>

                    <c-select :options="store.fontSelect" v-model="store.text.fontFamily"></c-select>
                </div>

<!--                <div>-->
<!--                    <p class="fs-5 fw-600 mb-1 text-muted">{{$trans('storefront::image_editor.text_align')}}</p>-->

<!--                    <c-select :options="store.textAlignSelect" v-model="store.textAlign">-->
<!--                        <template v-slot:selected="{ value }">-->
<!--                            <div class="d-flex align-items-center gap-1">-->
<!--                                <i :class="`las la-align-${value} fs-2`"></i>-->
<!--                                {{$trans(`storefront::image_editor.text_align.${value}`)}}-->
<!--                            </div>-->
<!--                        </template>-->
<!--                        <template v-slot:options="{ selectOption }">-->
<!--                            <div v-for="option in store.textAlignSelect" :key="option" @click="selectOption(option)">-->
<!--                                <div class="d-flex align-items-center gap-1">-->
<!--                                    <i :class="`las la-align-${option} fs-2`"></i>-->
<!--                                    {{$trans(`storefront::image_editor.text_align.${option}`)}}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </template>-->
<!--                    </c-select>-->
<!--                </div>-->

                <input type="text" class="form-control" v-model="store.text.textMessage">
            </div>

            <color-picker v-model="store.text.fontColor"></color-picker>
        </div>

        <div class="d-flex flex-column gap-4 mt-4">
            <div>
                <p class="fs-5 fw-600 text-muted">{{$trans('storefront::image_editor.font_size')}}</p>

                <div class="d-flex gap-4">
                    <range-slider :min="6" :max="120" v-model="store.text.fontSize" @input="handleFontSizeChange"></range-slider>

                    <div class="fw-500" style="min-width: 28px">
                        {{store.text.fontSize}}px
                    </div>
                </div>
            </div>

            <div>
                <p class="fs-5 fw-600 text-muted">{{$trans('storefront::image_editor.diameter')}}</p>

                <div class="d-flex gap-4">
                    <range-slider :min="60" :max="store.text.fontSize*50" v-model="store.text.diameter"></range-slider>

                    <div class="fw-500" style="min-width: 28px">
                        {{Math.round(store.text.diameter)}}px
                    </div>
                </div>
            </div>

            <div>
                <p class="fs-5 fw-600 text-muted">{{$trans('storefront::image_editor.kerning')}}</p>

                <div class="d-flex gap-4">
                    <range-slider :min="0" :max="200" v-model="store.text.kerning"></range-slider>

                    <div class="fw-500" style="min-width: 28px">
                        {{store.text.kerning}}px
                    </div>
                </div>
            </div>

            <div class="d-flex gap-4">
                <p class="fs-5 fw-600 text-muted">{{$trans('storefront::image_editor.flip')}}</p>

                <input type="checkbox" v-model="store.text.flipped">
            </div>

            <button type="button" class="btn btn-secondary btn-medium " @click="insertText">{{$trans('storefront::image_editor.add_text')}}</button>
        </div>
    </div>
</template>

<script>
import getImageEditor, {functions} from '../imageEditor';
import {useImageEditorStore} from "../store";

export default {
    setup() {
        const store = useImageEditorStore();

        return {
            store: store,
        }
    },
    data() {
        return {
            canvas: null,
        }
    },
    mounted() {
        this.store.text.old_fontSize = this.store.text.fontSize;
    },
    methods: {
        insertText () {
            functions.insertText();
        },
        getTextWidth(text, font) {
            // Create a canvas element dynamically
            let canvas = this.canvas || (this.canvas = document.createElement("canvas"));
            let context = canvas.getContext("2d");

            // Set the context's font property
            context.font = font;

            // Measure the text width
            let metrics = context.measureText(text);
            return metrics.width;
        },
        handleFontSizeChange (value) {
            if (!this.store.text.old_fontSize) return;

            let oldDiameter = this.store.text.diameter;
            let x = oldDiameter/this.store.text.old_fontSize;

            this.store.text.diameter = x * value;

            this.store.text.old_fontSize = this.store.text.fontSize;
        }
    },
}
</script>
